export default __webpack_public_path__ + "resources/icons/d231-12db.webp";